import dayjs, { Dayjs } from "dayjs";
import { unique } from "radash";
import { ScheduleVisitTableData } from "components/ScheduleVisitForm/types";
import {
  DoctorMSPShiftVisitType,
  DoctorMSSupportedLanguage,
  EdmSearchAvailabilityForDayQuery,
  EdmSearchAvailabilityQuery,
} from "lib/graphql/megaSchema";

export const roundTimeToNearestFiveMinutes = (date: Dayjs) => {
  const minutes = date.minute();
  const roundedMinutes = Math.ceil(minutes / 5) * 5;

  return date.minute(roundedMinutes).second(0).format("HH:mm");
};

export const languageToEmojiMap: Record<DoctorMSSupportedLanguage, string> = {
  EN: "🇬🇧",
  PL: "🇵🇱",
  UK: "🇺🇦",
  RU: "🇷🇺",
};

const slotTypeToVisitTypeMap: Record<string, DoctorMSPShiftVisitType> = {
  PERSONAL: "IN_PERSON",
  TELEMEDICAL: "TELEMEDICAL",
  INFECTIONS: "DOCTOR_TELEMEDICAL_INFECTION",
  INFECTIONS_PUBLIC: "DOCTOR_TELEMEDICAL_INFECTION",
  INFECTIONS_PRIVATE: "DOCTOR_TELEMEDICAL_INFECTION",
  NURSE_VISIT: "NURSE_IN_PERSON_INFECTION",
  PROCEDURES: "PROCEDURE",
  COLLECTION: "COLLECTION",
  USG: "RADIOLOGY_APPOINTMENT",
  SPECIALIST: "SPECIALIST",
  EXPRESS: "EXPRESS_APPOINTMENT",
  UNKNOWN: "IN_PERSON", //this is a guard for non-expected type
};

export const mapFromSlotTypeToVisitType = (
  slotType: string,
): DoctorMSPShiftVisitType => {
  const mappedVisitType =
    slotTypeToVisitTypeMap[slotType as keyof typeof slotTypeToVisitTypeMap] ??
    slotTypeToVisitTypeMap.UNKNOWN;
  return mappedVisitType;
};

export const transformShifts = (
  data: EdmSearchAvailabilityForDayQuery["edmSearchAvailabilityForDay"],
  availableStaff: EdmSearchAvailabilityQuery["edmSearchAvailability"]["medicalPeople"],
): ScheduleVisitTableData[] => {
  return unique(
    data
      .flatMap((entry) =>
        entry.shifts.map((shift) => {
          const staffId = shift.staffId;

          const staff = availableStaff.find((staff) => staff.id === staffId)!;

          return {
            id: `${shift.id}${entry.from}`,
            shiftDate: dayjs(entry.from).startOf("day").toISOString(),
            scheduledOn: entry.from,
            staff,
            languages: staff.languages ?? [],
            shift: {
              ...entry,
              shifts: entry.shifts
                .filter((shift) => shift.staffId === staffId)
                .map(({ id, version }) => ({ id, version })),
            },
          };
        }),
      )
      .sort((aShift, bShift) =>
        dayjs(aShift.scheduledOn).diff(dayjs(bShift.scheduledOn)),
      ),
    (data) => data.id,
  );
};
